module.exports = __webpack_public_path__ + "img/dp-guides.04f30197.svg";